import React, { useEffect, useState } from "react";
import { Link, useRouter } from "../router";
import { api } from "../api";

export default function ResetPasswordPage({ token }) {
  const { navigate } = useRouter();
  const [checking, setChecking] = useState(true);
  const [valid, setValid] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    api
      .get(`/api/auth/reset-password/${token}`)
      .then((d) => setValid(!!d.valid))
      .catch(() => setValid(false))
      .finally(() => setChecking(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword !== confirmPassword) {
      setError("New password and confirmation don't match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/api/auth/reset-password", { token, newPassword });
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page page-narrow">
      <div className="auth-card">
        <h1>Reset password</h1>

        {checking && <p className="muted">Checking your reset link…</p>}

        {!checking && !valid && !done && (
          <>
            <div className="alert alert-error">
              This reset link is invalid or has expired. Reset links are only good for one hour
              and can only be used once.
            </div>
            <p className="muted">
              <Link to="/forgot-password">Request a new link</Link>
            </p>
          </>
        )}

        {!checking && valid && !done && (
          <form onSubmit={submit}>
            {error && <div className="alert alert-error">{error}</div>}
            <label>
              New password
              <input
                type="password"
                autoComplete="new-password"
                minLength={8}
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </label>
            <label>
              Confirm new password
              <input
                type="password"
                autoComplete="new-password"
                minLength={8}
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </label>
            <button className="btn btn-primary btn-block" disabled={busy}>
              {busy ? "Saving…" : "Reset password"}
            </button>
          </form>
        )}

        {done && (
          <>
            <div className="alert alert-success">
              Your password has been reset. Any other devices you were logged in on have been
              signed out for safety.
            </div>
            <button className="btn btn-primary btn-block" onClick={() => navigate("/login")}>
              Log in
            </button>
          </>
        )}
      </div>
    </div>
  );
}
